function initialState() {
  return {
    // Dataset-based storage (primary + comparison)
    datasets: {
      primary: null,
      comparison: null,
    },

    isComparisonMode: false,

    selectedPodcasts: [],

    params: { from_date: "", to_date: "", offset: "" },
    comparisonParams: { from_date: "", to_date: "" },
  }
}

let state = initialState()

export { initialState, state }
